import { useEffect, useState } from "react";

export const Timer = () => {
  const [sec, setSec] = useState(0);
  const [min, setMin] = useState(2); // Start with 2 minutes for the countdown

  useEffect(() => {
    const endDate = new Date().getTime() + 2 * 60 * 1000; // 2 minutes in milliseconds

    const intervalId = setInterval(() => {
      const now = new Date().getTime();
      const timeLeft = endDate - now;

      const minutes = Math.floor((timeLeft % (1000 * 3600)) / (1000 * 60));
      const seconds = Math.floor((timeLeft % (1000 * 60)) / 1000);

      if (timeLeft > 0) {
        setMin(minutes);
        setSec(seconds);
      } else {
        clearInterval(intervalId);
        setMin(0);
        setSec(0);
      }
    }, 1000);

    return () => {
      clearInterval(intervalId);
    };
  }, []);

  const value = `${min}:${sec < 10 ? "0" + sec : sec}`;

  return value;
};
